import { ADMIN_RUNTIME_COMMANDS } from './adminRuntime';
import { assertRuntimeSaveSucceeded } from './saveOutcome';

/** Cloud data-wizard transaction boundary: save first, then start indexing. */
export async function persistCloudCrawlerSettings({
  runtime,
  shopId,
  settings,
  startIndexing = false,
}) {
  if (!runtime || !shopId
    || !runtime.supports(ADMIN_RUNTIME_COMMANDS.CRAWLER_SETTINGS_SAVE)) {
    throw new Error('Cloud crawler settings runtime is unavailable.');
  }

  const result = await runtime.sendMessageWithResponse(
    ADMIN_RUNTIME_COMMANDS.CRAWLER_SETTINGS_SAVE,
    { shopId, settings },
  );
  assertRuntimeSaveSucceeded(result, 'Crawler settings were not saved.');

  if (startIndexing) {
    if (!runtime.supports(ADMIN_RUNTIME_COMMANDS.INDEXING_START)) {
      throw new Error('Cloud catalog indexing runtime is unavailable.');
    }
    await runtime.sendMessageWithResponse(
      ADMIN_RUNTIME_COMMANDS.INDEXING_START,
      { shopId },
    );
  }

  return result;
}
